import useTrapTab from './trap-tab';

export default useTrapTab;
